import { render, staticRenderFns } from "./MailInfoDialog.vue?vue&type=template&id=6ca83e10&scoped=true&"
import script from "./MailInfoDialog.vue?vue&type=script&lang=js&"
export * from "./MailInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./MailInfoDialog.vue?vue&type=style&index=0&id=6ca83e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca83e10",
  null
  
)

export default component.exports